import * as GC from '@grapecity/spread-sheets';

export const suspendAll = (sheet: GC.Spread.Sheets.Worksheet, origin: string = null): boolean | void => {
  if (sheet) {
    const suspendState = sheet.isPaintSuspended();
    if (!suspendState) {
      sheet.suspendPaint();
      sheet.suspendEvent();
      sheet.suspendCalcService();
      // console.log(`❎ Suspended ${origin ? origin : ''}`);
    }
    return suspendState;
  }
};
